import React from 'react';
import PropTypes from 'prop-types';
import { PrintSize } from '../../../prop-types';
import PandaViewSimplePreviews from '../../../common/panda-view-simple-previews';
import EditablePhotoButtons from './editable-photo-buttons';

const EditablePhoto = (props) => {
  const {
    photo,
    isLastPhoto,
    onAdvancedEdit,
    recommendedPrintSize,
    showPreviewWarning,
    recommendedPrintSizeTextForPreview,
  } = props;

  return (
    <div className="d-flex">
      <div className="editable-photo-wrapper flex-shrink-0">
        <PandaViewSimplePreviews
          {...photo}
          isWallet={photo.size.title === 'Wallet'}
          size_area={photo.size.area}
          recommendedPrintSize={recommendedPrintSize}
          showSize={false}
          showQuantity={false}
          showPreviewWarning={showPreviewWarning}
          recommendedPrintSizeTextForPreview={
            recommendedPrintSizeTextForPreview
          }
        />
        <EditablePhotoButtons
          photo={photo}
          isLastPhoto={isLastPhoto}
          onAdvancedEdit={onAdvancedEdit}
        />
      </div>
    </div>
  );
};

EditablePhoto.propTypes = {
  photo: PrintSize,
  isLastPhoto: PropTypes.bool,
  availableSizes: PropTypes.arrayOf(PrintSize),
  sizesWithRootImage: PropTypes.arrayOf(PrintSize),
  onAdvancedEdit: PropTypes.func,
  showPreviewWarning: PropTypes.bool,
  recommendedPrintSizeTextForPreview: PropTypes.string,
}.isRequired;

export default EditablePhoto;
